import { ApprovalNewsListing } from "api/approvalManagement";
import { categoryList, newsDelete } from "api/news";
import CreateNews from "components/CreateNews";
import DetailsPage from "components/Details";
import useDebounce from "hook/useDebounce";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ButtonComp from "themes/elements/Button";
import ModalComp from "themes/elements/Modal";
import TabComp from "themes/elements/Tab";
import NewsTable from "themes/elements/Table/NewsTable";
import { retrieveUserData } from "utils/cryptoStorage";
import { isPermit } from "utils/permissionCheck";
import { getColumnConfig } from "./config";

function ApprovalManagement() {
  const userToken = retrieveUserData();
  let admin_user_id, admin_user_name;

  if (userToken) {
    ({ admin_user_id, admin_user_name } = userToken);
  }
  const [news, setNews] = useState(false);
  const [details, setDetails] = useState(false);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [newsData, setNewsData] = useState([]);
  const [totalPageNo, setTotalPageNo] = useState(0);
  const [categoryData, setCategoryData] = useState([]);
  const [loadCategory, setLoadCategory] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [status, setStatus] = useState(1);
  const [tabActive, setTabActive] = useState("1");
  const [isEdit, setEdit] = useState(false);
  const [duplicate, setDuplicate] = useState(false);
  const [loadTable, setLoadTable] = useState(false);
  const [dlt, setDlt] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [isHistory, setHistory] = useState(false);
  // filter states
  const [filterTitle, setFilterTitle] = useState("");
  const [filterAuthor, setFilterAuthor] = useState("");
  const [filterExpiry, setFilterExpiry] = useState(null);
  const [filterSchedule, setFilterSchedule] = useState(null);

  const [filterPublish, setFilterPublish] = useState(null);
  const [filterCategory, setFilterCategory] = useState("");

  // column headers based on the active tab (pending/History) and category data.
  const columnData = getColumnConfig(tabActive, categoryData);

  const handleDuplicate = (data) => {
    setSelectedNews(data);
    setEdit(false);
    setDuplicate(true);
    setNews(true);
    setCurrentPageNo(1);
  };

  const handleEdit = (data) => {
    setSelectedNews(data);
    setDuplicate(false);
    setEdit(true);
    setNews(true);
  };

  const handleNewsDelete = async (newsId) => {
    setIsLoading(true);
    try {
      const response = await newsDelete({
        newsId: Number(newsId),
      });
      fetchNews();
      if (response.statusCode === 200) {
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
      setIsLoading(false);
      setDlt(false);
    } catch (error) {
      toast.error(error);
      setIsLoading(false);
      setDlt(false);
    }
  };

  const dltModalFooter = (
    <div className="flex align-center justify-end gap-3">
      <ButtonComp onClick={() => setDlt(null)} variant="secondary">
        Cancel
      </ButtonComp>
      <ButtonComp
        variant="danger"
        loading={isLoading}
        onClick={() => {
          handleNewsDelete(selectedNews?.id);
        }}
      >
        Delete
      </ButtonComp>
    </div>
  );

  const onDeleteClick = (data) => {
    setSelectedNews(data);
    setDlt(true);
  };

  const tabsData = [
    {
      key: "1",
      label: "Pending",
      children: (
        <>
          {tabActive === "1" && (
            <NewsTable
              onDeleteAction={onDeleteClick}
              dataClick={(data) => {
                setDetails(true);
                setSelectedNews(data);
                setHistory(false);
              }}
              copyAction={false}
              column={columnData}
              pageSize={pageSize}
              setPageSize={setPageSize}
              totalPageNo={totalPageNo}
              data={newsData}
              setCurrentPageNo={setCurrentPageNo}
              handleEdit={handleEdit}
              isLoading={isLoading}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              tabActive={tabActive}
              currentPageNo={currentPageNo}
              handleDuplicate={handleDuplicate}
              filterTitle={filterTitle}
              setFilterTitle={setFilterTitle}
              filterAuthor={filterAuthor}
              setFilterAuthor={setFilterAuthor}
              setFilterPublish={setFilterPublish}
              setFilterExpiry={setFilterExpiry}
              setFilterCategory={setFilterCategory}
            />
          )}
        </>
      ),
    },
    {
      key: "2",
      label: "Scheduled",
      children: (
        <>
          {tabActive === "2" && (
            <NewsTable
              filterSchedule={filterSchedule}
              setFilterSchedule={setFilterSchedule}
              editAction={false}
              onDeleteAction={onDeleteClick}
              isLoading={isLoading}
              pageSize={pageSize}
              setPageSize={setPageSize}
              dataClick={(data) => {
                setDetails(true);
                setSelectedNews(data);
              }}
              totalPageNo={totalPageNo}
              currentPageNo={currentPageNo}
              handleEdit={handleEdit}
              column={columnData}
              data={newsData}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              setCurrentPageNo={setCurrentPageNo}
              tabActive={tabActive}
              handleDuplicate={handleDuplicate}
              filterTitle={filterTitle}
              setFilterTitle={setFilterTitle}
              filterAuthor={filterAuthor}
              setFilterAuthor={setFilterAuthor}
              setFilterPublish={setFilterPublish}
              setFilterExpiry={setFilterExpiry}
              setFilterCategory={setFilterCategory}
            />
          )}
        </>
      ),
    },
    {
      key: "3",
      label: "History",
      children: (
        <>
          {tabActive === "3" && (
            <NewsTable
              handleDuplicate={handleDuplicate}
              onDeleteAction={onDeleteClick}
              dataClick={(data) => {
                setDetails(true);
                setSelectedNews(data);
                setHistory(true);
              }}
              column={columnData}
              setPageSize={setPageSize}
              copyAction={false}
              totalPageNo={totalPageNo}
              data={newsData}
              pageSize={pageSize}
              isLoading={isLoading}
              currentPageNo={currentPageNo}
              setCurrentPageNo={setCurrentPageNo}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              tabActive={tabActive}
              filterTitle={filterTitle}
              setFilterTitle={setFilterTitle}
              filterAuthor={filterAuthor}
              setFilterAuthor={setFilterAuthor}
              setFilterPublish={setFilterPublish}
              setFilterExpiry={setFilterExpiry}
              setFilterCategory={setFilterCategory}
            />
          )}
        </>
      ),
    },
  ];
  useEffect(() => {
    const loadWards = async () => {
      try {
        const category = await categoryList();
        const formattedCategory = category?.data?.categories.map((cat) => ({
          id: cat.news_category_id,
          name: cat.news_category_name,
          color: cat.tag_color,
          status: cat.category_status_flg,
        }));
        setCategoryData(formattedCategory);
      } catch (error) {}
    };
    loadWards();
  }, [loadCategory]);

  const fetchNews = async () => {
    setIsLoading(true);
    const response = await ApprovalNewsListing(
      currentPageNo,
      pageSize,
      status,
      admin_user_id,
      filterTitle,
      filterPublish,
      filterExpiry,
      filterAuthor,
      filterCategory,
      filterSchedule
    );
    if (currentPageNo === 1) {
      setTotalPageNo(response?.meta?.total);
    }
    setCurrentPageNo(response?.meta?.current_page);

    const formattedData = response?.news.map((item) => ({
      id: item?.news_id,
      title: item?.title,
      avatar: null,
      category: item?.news_category_name,
      author: item?.author_name,
      authorIcon: item?.author_image,
      alert_date_time: item?.published_date || null,
      publisheddate: item?.published_date || "N/A",
      status: item?.news_status_flg,
      expirydate: item?.expiry_date,
      expirydatetime: item?.expiry_date_time || "N/A",
      message: item?.message_content,
      recipients_flg: item?.recipients_flg,
      source: item?.source,
      wards: item?.wards,
      top_news: item?.top_news_flg,
      news_image_filepath: item?.news_image_filepath,
      author_image_path: item?.author_image_filepath,
      abstract_content: item?.abstract_content ? item?.abstract_content : "",
      image_caption: item?.image_caption,
      category_id: item?.news_category_id,
      activity: item?.activities,
      banner_img: item?.news_image,
      allow_resubmission_flg: item?.allow_resubmission_flg,
      scheduled_date: item?.scheduled_date,
      author_image: item?.author_image,
      tabDate: item?.published_date_time || "N/A",
      tag_color: item?.tag_color,
    }));
    setNewsData(formattedData);
    setIsLoading(false);
  };

  const debouncedLoadNews = useDebounce(fetchNews, 300);

  useEffect(() => {
    debouncedLoadNews();
  }, [filterTitle, filterAuthor]);

  useEffect(() => {
    fetchNews();
  }, [
    currentPageNo,
    pageSize,
    loadTable,
    status,
    filterCategory,
    filterExpiry,
    filterPublish,
    filterSchedule,
    news,
  ]);

  function handleTabChange(key) {
    setSelectedNews(null);
    setCurrentPageNo(1);
    setSelectedData([]);
    setTabActive(key);
    setNewsData([]);
    switch (key) {
      case "1":
        setStatus(1);
        break;
      case "2":
        setStatus(5);
        break;
      default:
        setStatus(4);
        break;
    }
  }

  return (
    <>
      {news ? (
        <CreateNews
          approval={true}
          isDuplicate={duplicate}
          categoryData={categoryData}
          setLoadCategory={setLoadCategory}
          myNewsArticle
          setOpen={setNews}
          open={news}
          isEdit={isEdit}
          selectedNews={selectedNews}
          setDetails={setDetails}
          setLoadTable={setLoadTable}
        />
      ) : details ? (
        <DetailsPage
          Approval
          fetchNews={fetchNews}
          onEdit={(data) => {
            setNews(true);
            setSelectedData(data);
            setEdit(true);
          }}
          setOpen={setDetails}
          selectedNews={selectedNews}
          setLoadTable={setLoadTable}
          isHistory={isHistory}
          tabActive={tabActive}
          setSelectedNews={setSelectedNews}
        />
      ) : (
        <div className="page-wrapper flex flex-column gap-2">
          <div className="flex wrap gap-2 align-center justify-between">
            <h2 className="page-title">Approval Management</h2>
            {isPermit(3, "create") && (
              <ButtonComp
                onClick={() => {
                  setNews(true);
                  setEdit(false);
                }}
                prefix
              >
                Create news article
              </ButtonComp>
            )}
          </div>
          {isPermit(3, "approve_reject") && (
            <TabComp
              isLoading={isLoading}
              tabActive={tabActive}
              handleTabChange={handleTabChange}
              exportData={selectedData}
              count={selectedData?.length}
              data={tabsData}
            />
          )}
        </div>
      )}
      <ModalComp
        footer={dltModalFooter}
        CancelClick={() => setDlt(false)}
        open={dlt}
        setOpen={setDlt}
        title="Delete News"
      >
        Are you sure you want to delete the news titled '{selectedNews?.title}'
      </ModalComp>
    </>
  );
}

export default ApprovalManagement;
